export default "__VITE_ASSET__yMcV10NI__"